// extracted by mini-css-extract-plugin
module.exports = {"ingredient":"filling_ingredient__BTLzX"};